import type { NodeViewProps } from "@tiptap/core";
import { AccessionMentionNode } from "./accession-mention-node";
import { MaterialMentionNode } from "./material-mention-node";
import { TaxonMentionNode } from "./taxon-mention-node";

export const LinkedMentionNode = ({ ...props }: NodeViewProps) => {
  if (props.node.attrs.href?.includes("/taxon/")) {
    return <TaxonMentionNode link {...props} />;
  }
  if (props.node.attrs.href?.includes("/accession/")) {
    return <AccessionMentionNode link {...props} />;
  }
  return <MaterialMentionNode link {...props} />;
};

export const MentionNode = (props: NodeViewProps) => {
  if (props.node.attrs.href?.includes("/taxon/")) {
    return <TaxonMentionNode {...props} />;
  }
  if (props.node.attrs.href?.includes("/accession/")) {
    return <AccessionMentionNode {...props} />;
  }
  return <MaterialMentionNode {...props} />;
};
